var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCircleAnimation(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2311_17790)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24 12.0009C24 18.6283 18.6274 24.0009 12 24.0009C5.37258 24.0009 0 18.6283 0 12.0009C0 5.37344 5.37258 0.000854492 12 0.000854492C18.6274 0.000854492 24 5.37344 24 12.0009ZM1.80404 12.0009C1.80404 17.6319 6.36893 22.1968 12 22.1968C17.6311 22.1968 22.196 17.6319 22.196 12.0009C22.196 6.36978 17.6311 1.8049 12 1.8049C6.36893 1.8049 1.80404 6.36978 1.80404 12.0009Z",
    fill: "#D9D9D9",
    fillOpacity: 0.36
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.098 12.0009C23.5962 12.0009 24.0035 12.4053 23.9661 12.9021C23.823 14.802 23.2291 16.6452 22.2282 18.2765C21.0697 20.1647 19.411 21.6954 17.436 22.699C15.461 23.7025 13.2468 24.1398 11.0386 23.9623C8.83039 23.7848 6.71441 22.9995 4.92507 21.6934C3.13572 20.3873 1.74285 18.6113 0.900759 16.5623C0.0586664 14.5133 -0.19978 12.2711 0.154049 10.0842C0.507879 7.89734 1.46017 5.85108 2.90544 4.17213C4.15407 2.7216 5.72855 1.59415 7.49445 0.878798C7.95618 0.691755 8.46554 0.956476 8.61738 1.43094V1.43094C8.76922 1.90541 8.50566 2.40943 8.04647 2.6026C6.59687 3.21239 5.30397 4.15104 4.27269 5.34907C3.0447 6.77562 2.23557 8.51425 1.93493 10.3724C1.6343 12.2305 1.85389 14.1356 2.56939 15.8766C3.28488 17.6175 4.46835 19.1265 5.98869 20.2362C7.50903 21.346 9.3069 22.0132 11.1831 22.164C13.0594 22.3148 14.9407 21.9433 16.6188 21.0906C18.2969 20.238 19.7061 18.9374 20.6905 17.333C21.5172 15.9857 22.0171 14.4682 22.1561 12.9017C22.2001 12.4055 22.5998 12.0009 23.098 12.0009V12.0009Z",
    fill: "#1943DC"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2311_17790"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0 0.000854492)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircleAnimation);
export default __webpack_public_path__ + "static/media/circleAnimation.1c000e6f866db6b426f2cd5f0f535277.svg";
export { ForwardRef as ReactComponent };